import { useEffect, useState } from "react";
import {useNavigate} from "react-router-dom";
import { fetchBranding } from "../services/branding";

export default function Navbar() {

    const navigate = useNavigate();
    const [branding, setBranding] = useState({});

    const logout = () => {
        localStorage.removeItem("token");
        navigate("/login");
    };

    useEffect(() => {
        fetchBranding().then(setBranding);
    }, []);

    return (
        <div className="dashboard-header">
            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                {branding.logoUrl && (
                    <img
                        src={branding.logoUrl}
                        alt="Store logo"
                        style={{ height: "34px", objectFit: "contain" }}
                    />
                )}
                <h2 style={{ margin: 0 }}>{branding.storeName || "Katz's Logger Dashboard"}</h2>
            </div>
            <div>
                <button className="btn btn-green" onClick={() => navigate("/")}>
                    Dashboard
                </button>
                <button className="btn btn-red" onClick={logout}>
                    Logout
                </button>
            </div>

        </div>
    );
}

const styles = {
    navbar: {
        display: "flex",
        justifyContent: "space-between",
        padding: "12px 20px",
        background: "#ccc",
        color: "#000"
    },

    navButton: {
        padding: "8px 14px",
        background: "#4CAF50",
        border: "none",
        color: "white",
        cursor: "pointer"
    },

    logoutButton: {
        padding: "8px 14px",
        background: "#e53935",
        border: "none",
        color: "white",
        cursor: "pointer"
    }
};